(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizznova-main-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('[data-rz-product-thumb]');
    if (thumb) {
      var root = thumb.closest('[data-rz-product-page]');
      var mediaId = thumb.getAttribute('data-media-id');
      root.querySelectorAll('[data-rz-product-thumb]').forEach(function(item) {
        item.classList.toggle('is-active', item === thumb);
      });
      var mediaItems = Array.from(root.querySelectorAll('[data-rz-product-media]'));
      var selectedMedia = mediaItems.find(function(item) { return item.getAttribute('data-media-id') === mediaId; });
      if (window.matchMedia('(max-width: 980px)').matches && selectedMedia) {
        root.querySelector('[data-rz-product-gallery]').scrollTo({ left: selectedMedia.offsetLeft, behavior: 'smooth' });
      } else {
        mediaItems.forEach(function(item) {
          item.classList.toggle('is-active', item === selectedMedia);
        });
      }
      return;
    }

    var quantityButton = event.target.closest('[data-rz-quantity-change]');
    if (quantityButton) {
      var quantity = quantityButton.closest('[data-rz-quantity]');
      var input = quantity && quantity.querySelector('[data-rz-quantity-input]');
      if (!input) return;
      var change = Number(quantityButton.getAttribute('data-rz-quantity-change')) || 0;
      var nextValue = Math.max(Number(input.min) || 1, (Number(input.value) || 1) + change);
      input.value = nextValue;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.querySelectorAll('[data-rz-product-gallery]').forEach(function(gallery) {
    var root = gallery.closest('[data-rz-product-page]');
    var mediaItems = Array.from(gallery.querySelectorAll('[data-rz-product-media]'));
    if (!root || mediaItems.length < 2) return;
    var ticking = false;
    gallery.addEventListener('scroll', function() {
      if (ticking || !window.matchMedia('(max-width: 980px)').matches) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        var index = Math.max(0, Math.min(mediaItems.length - 1, Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1))));
        var mediaId = mediaItems[index].getAttribute('data-media-id');
        root.querySelectorAll('[data-rz-product-thumb]').forEach(function(thumb) {
          thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === mediaId);
        });
        ticking = false;
      });
    }, { passive: true });
  });

  document.addEventListener('change', function(event) {
    var select = event.target.closest('[data-rz-product-variant-select]');
    if (!select) return;
    var root = select.closest('[data-rz-product-page]');
    var option = select.options[select.selectedIndex];
    var variantInput = root.querySelector('[data-rz-product-variant-id]');
    var price = root.querySelector('[data-rz-product-price]');
    var addButton = root.querySelector('.rz-product__add');
    var buyNowButton = root.querySelector('[data-rz-buy-now]');
    var available = option.getAttribute('data-available') === 'true';

    if (variantInput) variantInput.value = option.value;
    if (price) price.textContent = option.getAttribute('data-price') || price.textContent;
    if (addButton) {
      addButton.disabled = !available;
      var textNode = Array.from(addButton.childNodes).find(function(node) {
        return node.nodeType === 3 && node.textContent.trim();
      });
      if (textNode) textNode.textContent = available ? ' Add to cart ' : ' Sold out ';
    }
    if (buyNowButton) buyNowButton.disabled = !available;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizznova-product-rail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-rn-product-rail-section] [data-rn-scroll]');
    if (!button) return;
    var shell = button.closest('.rn-carousel-shell');
    var rail = shell && shell.querySelector('[data-rn-rail]');
    if (!rail) return;
    var direction = button.getAttribute('data-rn-scroll') === 'left' ? -1 : 1;
    rail.scrollBy({ left: direction * Math.max(rail.clientWidth * .85, 280), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rizznova-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('product-recommendations[data-url]').forEach(function(section) {
    if (section.dataset.rzLoaded === 'true' || section.innerHTML.trim()) return;
    section.dataset.rzLoaded = 'true';
    fetch(section.dataset.url)
      .then(function(response) { return response.ok ? response.text() : ''; })
      .then(function(text) {
        if (!text) return;
        var documentFragment = new DOMParser().parseFromString(text, 'text/html');
        var replacement = documentFragment.querySelector('#' + section.id);
        if (!replacement || !replacement.innerHTML.trim()) return;
        section.innerHTML = replacement.innerHTML;
        document.dispatchEvent(new CustomEvent('rz:products:rendered'));
      })
      .catch(function() {});
  });

  } catch(e) { console.error(e); }
})();
})();
